<template>
  <div v-loading="loading">

    <Head />
    <div class="body">
      <!-- 状态切换 -->
      <div class="tabs">
        <el-tabs v-model="status" type="card" @tab-click="search">
          <!--  全部-->
          <el-tab-pane :label="$t('message.allStatus')" name="0"></el-tab-pane>
          <!--  其他状态-->
          <el-tab-pane v-for="item in tabsList" :key="item.status" :label="item.status_name + `(${item.count})`"
            :name="item.status + ''"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 搜索 -->
        <div class="Container">
          <el-date-picker v-model="datas.datetimeStart" type="date" value-format="yyyy-MM-dd" clearable
            :placeholder="$t('message.startDateTC')" @change="handleStartDateChange">
          </el-date-picker>
        </div>
        <div class="Container">
          <el-date-picker v-model="datas.datetimeEnd" type="date" :placeholder="$t('message.dateClosedTC')"
            value-format="yyyy-MM-dd" :picker-options="endDatePickerOptions" clearable>
          </el-date-picker>
        </div>
        <!-- 订单号 -->
        <div class="Container">
          <el-input v-model="datas.order_sn" clearable :placeholder="$t('message.orderNumber')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 赔款单 -->
        <!-- <div class="Container">
          <el-input v-model="datas.reparation_un_confirm" clearable :placeholder="$t('message.billOfIndemnity')"
            onfocus="this.select()"></el-input>
        </div> -->
        <!-- 客户ID -->
        <div class="Container">
          <el-input v-model="datas.user_id" clearable :placeholder="$t('message.clientID')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 采购 -->
        <div class="Container">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 业务 -->
        <div class="Container">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="Container">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="Container btn">
          <!--  搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!--  重置 -->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05">
            {{ $t("message.choose") }}
            <!--  订单号-->
          <li class="flex2">
            {{ $t("message.orderNumber") }}
          </li>
          </li>
          <!-- 番号 -->
          <li class="flex05">{{ $t("message.mash") }}</li>
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 业务编辑商品属性 -->
          <li class="flex2">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
          <!-- 附加服务  -->
          <li class="flex2">当前附加服务</li>
          <!-- 实时数据 -->
          <li>{{ $t("message.quotationData") }}</li>
          <!-- 本次到货数  -->
          <li>{{ $t("message.currentArrivalQuantity") }}</li>
          <!-- 问题类别  -->
          <li>{{ $t("message.typeOfProblem") }}</li>
          <!-- 问题数 -->
          <li>{{ $t("message.numberOfProblems") }}</li>
          <!-- 问题图片 -->
          <li class="flex2">{{ $t("message.problemPic") }}</li>
          <!-- 待退款数量 -->
          <li class="flex2">{{ $t("message.pendingRefundQuantity") }}</li>
          <!-- 修改后附加服务 -->
          <li class="flex2">{{ $t("message.modifiedAdditionalServices") }}</li>
          <!-- 具体问题描述  -->
          <li class="flex2">{{ $t("message.specificProblemDescription") }}</li>
          <!-- 业务决策备注 -->
          <li class="flex2">{{ $t("message.businessDecisionRemarks") }}</li>
          <!-- FBA（配货）确认备注 -->
          <li class="flex2">{{ $t("message.fbaPickingConfirmationRemarks") }}</li>
          <!-- 关联赔款单 -->
          <li class="flex2">{{ $t("message.relatedCompensationOrder") }}</li>
          <!-- 问题状态 -->
          <li>{{ $t("message.status") }}</li>
        </ol>
        <!-- 列表 -->
        <div class="detail" v-for="(item, index) in list" :key="index">
          <!-- 头部 -->
          <div class="head">
            <div class="inco" @click="isListShow(index)">
              <i class="el-icon-arrow-up" v-if="item.show"></i>
              <i class="el-icon-arrow-right" v-else></i>
            </div>
            <!-- 提出时间 -->
            <div class="item">
              <div>
                <p>{{ $t("message.forwardTime") }}</p>
                {{ item.created_at }}
              </div>
            </div>
            <!--提出人： -->
            <div class="item">
              {{ $t("message.peoplePutForward") }}:
              {{ item.created_by_realname }}
            </div>
            <!-- 配送单 -->
            <div class="item">
              {{ $t("message.porder") }}:
              <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank" class="a-link">
                {{ item.porder_sn }}
              </router-link>
            </div>
          </div>
          <template v-if="item.show">
            <ul v-for="(items, indexs) in item.list" :key="indexs">
              <!-- 选择 -->
              <li class="flex05">
                <label>
                  <el-checkbox v-model="items.checked" @change="radioItem" slot="reference"></el-checkbox>
                  <!-- <el-popover placement="right" title="合计" width="200" trigger="focus">
                    <statistics :checkList="checkList" />
                  </el-popover> -->
                </label>
              </li>
              <!--  订单号-->
              <li class="flex2">
                <router-link :to="'/orderPaymentDetail?order_sn=' + items.order_sn" target="_blank" class="a-link">
                  {{ items.order_sn }}
                </router-link>
              </li>
              <!-- 番号 -->
              <li class="flex05">
                {{ items.sorting }}
              </li>
              <!--照片-->
              <li>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="items.link" target="_blank" slot="reference">
                      <img :src="items.pic" alt="" />
                    </a>
                  </el-popover>
                </div>
              </li>
              <!-- 商品属性 -->
              <li class="flex2">
                <div class="template">
                  <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                    <span>{{ skuItem.key }}:</span>
                    <span>{{ skuItem.value }}</span>
                  </p>
                </div>
              </li>
              <!--附加服务  -->
              <li class="flex2">
                <el-popover placement="bottom-start" width="500" trigger="click" v-if="items.option">
                  <el-table :data="items.option" border size="mini" show-summary sum-text="合计.元" max-height="500px">
                    <el-table-column property="name" label="附加服务(中文)" align="center"></el-table-column>
                    <el-table-column property="name_translate" label="附加服务(日文)" align="center"></el-table-column>
                    <el-table-column property="num" label="数量" align="center"></el-table-column>
                    <el-table-column label="单价" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.price }} {{ scope.row.unit }}
                      </template>
                    </el-table-column>
                    <el-table-column property="unit" label="单位" align="center"></el-table-column>
                    <el-table-column label="小计.元" align="center" property="total">
                    </el-table-column>
                  </el-table>
                  <div class="template" slot="reference">
                    <div v-for="(opti, optis) in items.option" :key="optis" style="color: #2c96e7;">
                      <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}x{{ opti.price }} {{ opti.unit }}</p>
                    </div>
                  </div>
                </el-popover>
              </li>
              <!--实时数据 -->
              <li>
                <div class="template">
                  <!-- 数量 -->
                  <p>{{ $t("message.number") }}:{{ items.confirm_num }}</p>
                  <!-- 价格 -->
                  <p>{{ $t("message.price") }}:{{ items.confirm_price }}</p>
                  <!-- 运费-->
                  <p>
                    {{ $t("message.freight") }}:{{ items.confirm_price }}
                  </p>
                </div>
              </li>
              <!-- 本次到货数  -->
              <li>{{ items.porder_detail_num }}</li>
              <!--问题类别  -->
              <li>{{ items.type_name }}</li>
              <!-- 问题产品数 -->
              <li>
                {{ items.num }}
              </li>
              <!-- 问题图片 -->
              <li class="flex2">
                <div class="imgList">
                  <div class="imgs" v-for="(imgs, imgIndex) in items.in_sale_image" :key="imgIndex">
                    <!-- <div class="index" v-if="imgs.image">
                      {{ imgIndex + 1 }}
                    </div> -->
                    <el-image v-if="imgs.image"
                      :src="imgs.isOss ? imgs.image + '?x-oss-process=image/resize,p_10' : imgs.image"
                      :preview-src-list="[imgs.image]">
                    </el-image>
                    <!-- <img src="@/assets/icon/eye.png" alt="" class="el-icon-open" v-if="imgs.client_show"> -->
                  </div>
                </div>
              </li>
              <!-- 待退款数量 -->
              <li class="flex2">
                <span style="color:#B4272D; ">
                  {{ $t("message.pendingRefundQuantity") }}： {{ items.new_num }}
                </span>
              </li>
              <!-- 修改后附加服务  -->
              <li class="flex2">
                <el-popover placement="bottom-start" width="500" trigger="click" v-if="items.new_option">
                  <el-table :data="items.new_option" border size="mini" show-summary sum-text="合计.元" max-height="500px">
                    <el-table-column property="name" label="附加服务(中文)" align="center"></el-table-column>
                    <el-table-column property="name_translate" label="附加服务(日文)" align="center"></el-table-column>
                    <el-table-column property="num" label="数量" align="center"></el-table-column>
                    <el-table-column label="单价" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.price }} {{ scope.row.unit }}
                      </template>
                    </el-table-column>
                    <el-table-column property="unit" label="单位" align="center"></el-table-column>
                    <el-table-column label="小计.元" align="center" property="total">
                    </el-table-column>
                  </el-table>
                  <div class="template" slot="reference">
                    <div v-for="(opti, optis) in items.new_option" :key="optis" style="color: #2c96e7;">
                      <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}x{{ opti.price }} {{ opti.unit }}</p>
                    </div>
                  </div>
                </el-popover>
              </li>
              <!-- 具体问题描述 -->
              <li class="flex2 remark-border">
                {{ items.description }}
              </li>
              <!-- 业务决策备注 -->
              <li class="flex2 remark-border">
                {{ items.y_deal }}
              </li>
              <!--  FBA（配货）确认备注 -->
              <li class="flex2 remark-border" style=" border-right: 1px solid #ccc;">
                {{ items.p_deal }}
              </li>
              <!-- 关联赔款单 -->
              <li class="flex2 ">
                <div class="template">
                  <div class="row" v-for="(reparation, reparationIndex) in items.in_sale_reparation"
                    :key="reparationIndex" v-show="reparation.status != -1">
                    <div class="pk">
                      <router-link :to="'/reparationList?reparation_sn=' + reparation.reparation_sn" target="_blank"
                        class="a-link">
                        {{ reparation.reparation_sn }}
                      </router-link>
                    </div>
                    <div class="status">{{ reparation.reparation.status_name }}
                      <i class="el-icon-error"
                        @click="delReparation(reparation, items.in_sale_reparation, reparationIndex)"
                        v-if="isAuth(628) && items.status != -1"></i>
                    </div>
                  </div>
                </div>
              </li>
              <!-- 问题状态 -->
              <li>
                <div class="template">
                  <p style="color: rgb(250, 80, 88);">
                    {{ items.status_name }}</p>
                </div>
              </li>
            </ul>
          </template>
          <!-- </div> -->
        </div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[50, 80, 100, 200]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 操作 -->
      <div class="operation">
        <!-- 全选 -->
        <el-checkbox v-model="checked" @change="allChecked">
          {{ $t("message.allChecked") }}
        </el-checkbox>
        <!-- 同ID商品 -->
        <el-button type="primary" size="small" @click="productWithTheSameId" class="primary">
          {{ $t("message.productWithTheSameId") }}
        </el-button>
        <!-- 同店铺商品 -->
        <el-button type="primary" size="small" @click="sameStoreProduct" class="primary">
          {{ $t("message.sameStoreProduct") }}
        </el-button>
        <!-- 复制商品信息 -->
        <el-button type="primary" size="small" @click="copyText" class="primary">
          {{ $t("message.copyProductInformation") }}
        </el-button>
        <!-- 问题产品取消 -->
        <el-button type="primary" size="small" @click="inSaleCancel" class="dark" v-if="isAuth(622)">
          {{ $t("message.problemProductCancellation") }}
        </el-button>
        <!-- 附加服务修改 -->
        <el-button type="primary" size="small" @click="editOption" class="primary" style="margin-left: 300px;"
          v-if="isAuth(624)">
          {{ $t("message.editAdditionalServices") }}
        </el-button>
        <!-- 退款数量确认 -->
        <el-button type="primary" size="small" @click="refundQuantityConfirmation" class="primary" v-if="isAuth(623)">
          {{ $t("message.refundQuantityConfirmation") }}
        </el-button>
        <!-- 关联赔款单 -->
        <el-button type="primary" size="small" @click="relatedCompensationOrder" class="primary" v-if="isAuth(627)">
          {{ $t("message.relatedCompensationOrder") }}
        </el-button>
        <!-- FBA（配货）确认 -->
        <el-button type="primary" size="small" class="fr primary" @click="fbaPickingConfirmation" v-if="isAuth(626)">
          {{ $t("message.fbaPickingConfirmation") }}
        </el-button>
        <!-- 业务决策 -->
        <el-button type="primary" size="small" class="fr " @click="businessDecisions" v-if="isAuth(625)">
          {{ $t("message.businessDecisions") }}
        </el-button>
      </div>
    </div>
    <!-- 附加服务 -->
    <editOptions v-if="optionsDialogVisible" :option="optionsList" :itemsData="itemsData" :checkList="checkList" />
    <!-- 退款数量确认   -->
    <updateNewNum ref="updateNewNum" :checkList="checkList" />
    <!-- 新增赔款单 -->
    <claimIndemnity ref="claimIndemnity" :reparation_sn="reparation_sn" :type="reparation_type"
      :checkList="checkList" />
    <!-- 关联赔款单 -->
    <relatedCompensationOrder ref="relatedCompensationOrder" :checkList="checkList" />
    <!-- 业务决策 -->
    <businessDecisions ref="businessDecisions" :list="disposeList" />
    <!-- 配货确认 -->
    <distributionProcessed ref="distributionProcessed" :list="disposeList" />
  </div>
</template>
<script>
import Head from "@/components/header/detailHeader.vue";
import editOptions from '../components/editOptions'
import { vipList } from '@/utlis/options'
import { getColor } from "@/utlis/utlis";
import updateNewNum from './components/updateNewNum'
import claimIndemnity from './components/claimIndemnity'
import relatedCompensationOrder from './components/relatedCompensationOrder'
import businessDecisions from './components/businessDecisions'
import distributionProcessed from './components/distributionProcessed'
export default {
  metaInfo: {
    title: "售中问题",
  },
  components: {
    Head,
    editOptions,
    updateNewNum,
    claimIndemnity,
    relatedCompensationOrder,
    businessDecisions,
    distributionProcessed
  },
  data() {
    return {
      vipList,
      tabsList: [],
      status: this.$route.query.status ? this.$route.query.status : '0',
      datas: {
        status: '',
        page: 1,
        pageSize: 50,
        datetimeStart: "",
        datetimeEnd: "",
        express_no: "",
        purchase_no: "",
        order_sn: this.$route.query.order_sn,
        user_id: "",
        org_id: "",
        admin_id: "",
        overdue: '',
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.datas.datetimeStart) {
            const startDate = new Date(this.datas.datetimeStart);
            return time.getTime() < startDate.getTime();
          }
          return false;
        }
      },
      problem_goods_id: '',
      loading: false,//上传图片用
      userList: [],
      total: 0,
      //列表数据
      list: [],
      orderDetailsInfo: null,
      checked: false,
      //选择中的订单
      checkList: [],
      disposeList: [], //处理的交易号订单
      //修改option
      optionsDialogVisible: false,
      optionsList: [],
      itemsData: {},
      // 订单处理
      itemDetail: [],
      //   业务翻译
      businessTranslationDialogVisible: false,
      //   采购处理
      procurementProcessDialogVisible: false,
      // 数量价格运费修改
      quantityPriceFreightModificationDialogVisible: false,
      //   业务决策
      businessDecisionsDialogVisible: false,
      //产品退换货
      productReturnAndExchangeDialogVisible: false,
      // 临时备注
      temporaryRemarksDialogVisible: false,
      selectedIDs: [], //选中的商品ID
      order_purchase_id: 0,//检品状态详情
      userRole: localStorage.getItem('japanUserRoleStatus'), //工种
      node_list: [],// 时间节点
      getColor,
      reparation_sn: '',
      reparation_type: '',
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    problemTypes() {
      return this.$store.state.problemTypes;
    },
  },
  created() {

    let query = this.$route.query
    if (query.user_id) {
      this.datas.user_id = query.user_id
    }

    this.inSaleList();
  },
  methods: {
    //结束时间大于开始时间
    handleStartDateChange() {
      // If the start date is after the end date, clear the end date
      if (this.datas.datetimeStart && this.datas.datetimeEnd) {
        const startDate = new Date(this.datas.datetimeStart);
        const endDate = new Date(this.datas.datetimeEnd);
        if (startDate > endDate) {
          this.datas.datetimeEnd = '';
        }
      }
    },
    inSaleList() {
      this.datas.status = this.status
      this.checked = false;
      this.$api.inSaleApi.inSaleList(this.datas).then((res) => {
        // this.orderDetailsInfo = res.data.orderInfo;
        this.total = res.data.total;
        // 计算option 总价
        res.data.data.forEach((item) => {
          item.show = true;
          //   item.checked = false
          item.list.forEach((items) => {
            items.checked = false;
            //   给修改option用
            items.total = items.confirm_num * items.confirm_price;
            if (items.option) {
              items.option.forEach((optin, index) => {
                if (optin.price_type == 1) {
                  optin.total =
                    (optin.price / 100) *
                    items.confirm_price *
                    optin.num
                } else {
                  optin.total = optin.num * optin.price
                }
                optin.total = optin.total.toFixed(2)
              });
            }
            if (items.new_option) {
              items.new_option.forEach((optin, index) => {
                if (optin.price_type == 1) {
                  optin.total =
                    (optin.price / 100) *
                    items.confirm_price *
                    optin.num
                } else {
                  optin.total = optin.num * optin.price
                }
                optin.total = optin.total.toFixed(2)
              });
            }
          });
        });
        this.list = res.data.data;
        // console.log(this.list);
      });
      this.listTabCount()
    },
    //数量统计
    listTabCount() {
      this.$api.inSaleApi.listTabCount().then(res => {
        this.tabsList = res.data
      })
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.inSaleList();
    },
    // 重置
    reset() {
      this.datas = {
        status: "0",
        page: 1,
        pageSize: 50,
        datetimeStart: "",
        datetimeEnd: "",
        order_sn: "",
        user_id: "",
      };
      this.inSaleList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.inSaleList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.inSaleList();
    },
    // 是否显示商品列表
    isListShow(i) {
      this.list[i].show = !this.list[i].show;
      this.$forceUpdate();
    },
    // 单选
    radioItem() {
      this.checkList = [];
      this.list.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkList = [];
      this.list.forEach((item) => {
        item.checked = this.checked;
        item.list.forEach((items) => {
          items.checked = this.checked;
          if (items.checked) {
            this.checkList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    // 同id的商品
    productWithTheSameId() {
      let ids = [];
      this.list.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            ids.push(items.goods_id);
          }
        });
      });
      this.list.forEach((item) => {
        item.list.forEach((items) => {
          ids.forEach((id) => {
            if (id == items.goods_id) {
              items.checked = true;
            }
          });
        });
      });
      this.$forceUpdate();
    },
    // 同店铺的商品
    sameStoreProduct() {
      let ids = [];
      this.list.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            ids.push(items.shop_id);
          }
        });
      });
      this.list.forEach((item) => {
        item.list.forEach((items) => {
          ids.forEach((id) => {
            if (id == items.shop_id) {
              items.checked = true;
            }
          });
        });
      });
      this.$forceUpdate();
    },
    // 点击修改option
    editOption() {
      if (this.checkList == false) return this.$message.error("未选择问题产品");
      if (!this.checkList.every(item => item.status == 10))
        return this.$message.error("只有待业务决策状态下的问题产品能修改option");
      let itemData = JSON.parse(JSON.stringify(this.checkList[0]))
      this.optionsList = itemData.new_option ? itemData.new_option :
        itemData.option
      this.itemsData = itemData
      this.optionsDialogVisible = true;
    },
    // 成功修改option
    successOption(option) {
      this.inSaleList();
      this.optionsDialogVisible = false;
    },
    // 选择中的订单
    changeCheckList() {
      this.disposeList = [];
      this.list.forEach((item) => {
        let data = null
        let list = item.list.filter((items) => items.checked)
        if (list != false) {
          data = JSON.parse(JSON.stringify(item))
          data.list = JSON.parse(JSON.stringify(list))
          data.list.forEach(items => {
            items.checked = false
          })
        }
        if (data != null) {
          this.disposeList.push(data)
        }
      });
    },
    // 修改后数据编辑
    quantityPriceFreightModification() {
      if (this.checkList == false) return this.$message.error("未选择问题产品");
      if (this.checkList.length > 1)
        return this.$message.error("只能选择一个问题产品修改后数据编辑");
      this.itemsData = this.checkList[0];
      this.quantityPriceFreightModificationDialogVisible = true;
    },
    //业务决策
    businessDecisions() {
      if (this.checkList == false) return this.$message.error("未选择问题产品");
      this.changeCheckList();
      this.$refs.businessDecisions.dialogVisible = true
      this.$refs.businessDecisions.checked = false
    },
    //配货确认
    fbaPickingConfirmation() {
      if (this.checkList == false) return this.$message.error("未选择问题产品");
      this.changeCheckList();
      this.$refs.distributionProcessed.dialogVisible = true
      this.$refs.distributionProcessed.checked = false

    },
    // 退回待业务决策
    returnToPendingBusinessDecision(status) {
      this.$confirm(
        this.$t("message.isReturnToPendingBusinessDecision"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            data: [],
          };
          this.list.forEach((item) => {
            item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
              groupByPurchaseNo.list.forEach((items) => {
                if (items.checked) {
                  datas.data.push({ problem_goods_id: items.problem_goods_id });
                }
              });
            });
          });
          this.$api.inSaleApi.backToYdeal(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.inSaleList();
          });
        })
        .catch(() => { });
    },
    //产品退换货
    productReturnAndExchange() {
      this.$refs.productReturnAndExchange.dialogVisible = true;
    },
    //临时备注
    temporaryRemarks() {
      this.changeCheckList();
      if (this.checkList == false) return this.$message.error("请选择订单");
      this.temporaryRemarksDialogVisible = true;
    },
    // 重提问题产品
    rehashTheProblemProduct(status) {
      this.changeCheckList();
      let datas = {
        order_purchase_id: [],
        inspect_detail_id: [],
      };
      this.checkList.forEach((item) => {
        datas.order_purchase_id.push(item.order_purchase_id);
      });
      //   if (order_sn.length > 1)
      //     return this.$message.error(this.$t("message.danGeDanDingDan"));
      this.$store.dispatch("getProblemList", datas);
      this.checked = false;
      this.allChecked();
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.inSaleList();
    },
    //问题产品取消
    inSaleCancel() {
      if (this.checkList == false) return this.$message.error("请选择订单");
      let datas = {
        ids: [],
      };
      this.checkList.forEach((item) => {
        datas.ids.push(item.id);
      });
      if (!this.checkList.every(item => item.status == 10)) return this.$message.error('当前已选中的问题产品有不是待业务决策状态，无法取消，请确认要取消的问题产品是否正确')
      this.$confirm(
        this.$t("message.isProblemProductCancellation"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {

          this.$api.inSaleApi.inSaleCancel(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.inSaleList();
          });
        })
        .catch(() => { });
    },
    //复制选择商品信息
    copyText() {
      if (this.checkList === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      this.checkList.forEach((item) => {
        if (this.userRole == 2) { //采购工种特殊
          let size = ''
          item.detail_y.forEach((items, indexs) => {
            size += `${items.key}: ${items.value} `
          })
          copyUrl += `注文番号:${item.order_sn}\n商品番号:${item.sorting}\n链接:${item.link}`
        } else {
          copyUrl += `注文番号：${item.order_sn}\n${item.sorting}番  ${item.link}\n`
        }
      });
      this.copy(copyUrl)
    },
    //退款数量确认
    refundQuantityConfirmation() {
      if (this.checkList == false) return this.$message.error("请选择订单");
      if (!this.checkList.every(item => item.status == 10)) return this.$message.error('当前选中的问题产品有不是待业务决策状态，无法修改退款数量，请检查。')
      if (this.checkList.some(item => item.type == 1)) return this.$message.error('当前选中的问题产品有是option变更类型的售中问题，无法退数量。')
      this.$refs.updateNewNum.dialogVisible = true
      this.$refs.updateNewNum.new_num = ''

    },
    // 删除关联赔款单
    delReparation(reparation, reparationList, reparationIndex,) {
      this.$confirm(
        '是否确认解除关联。',
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.inSaleApi.delReparation({ ids: [reparation.id] }).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            reparationList.splice(reparationIndex, 1)
            this.$forceUpdate()
          });
        })
        .catch(() => { });
    },
    //关联赔款单
    relatedCompensationOrder() {
      if (this.checkList == false) return this.$message.error("请选择订单");
      if (!this.checkList.every(item => item.status != -1)) return this.$message.error('当前问题产品已取消，无法进行关联赔款单')
      this.$refs.relatedCompensationOrder.radio = '1'
      this.$refs.relatedCompensationOrder.reparation_sn = ''
      this.$refs.relatedCompensationOrder.dialogVisible = true

    },
    //创建赔款单
    getNewReparationSn() {
      this.$api.capitalApi.getNewReparationSn().then(res => {
        this.reparation_sn = res.data
        this.reparation_type = '待提出'
        this.$refs.claimIndemnity.addIndemnity()
      })
    },

  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.body {
  padding: 20px 20px 120px;
  min-width: 1872px;

  .search {
    margin: 20px 0;
    display: flex;

    .Container {
      margin-right: 24px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      /deep/.el-date-editor,
      .el-select {
        width: 217px;
      }

      /deep/.el-cascader {
        width: 217px;
      }
    }

    .btn {
      width: 200px;
    }
  }

  .tabs {
    // background-color: #f5f5f5;
    margin-bottom: 20px;
    position: relative;

    .btn {
      position: absolute;
      top: 0;
      right: 0;
    }

    /deep/.el-tabs__header {
      margin: 0;
    }
  }

  .table {
    ol {
      display: flex;
      font-size: 14px;
      height: 40px;
      background: #edeff4;
      color: #333;
      position: sticky !important;
      top: 0;
      left: 0;
      z-index: 999;
    }

    ul {
      display: flex;
      border-bottom: 1px solid #e8e8e8;
      padding: 10px 0;
      font-size: 12px;
      transition: 0.25s;

      &:hover {
        background-color: #eee;
        cursor: pointer;
      }

      li {
        width: 100%;
        overflow: hidden;
        //   max-height: 80px;

        .template {
          text-align: left;
          width: 100%;
          max-height: 120px;
          overflow-y: auto;

          p {
            line-height: 20px;
          }
        }

        .scope {
          max-height: 100px;

          p {
            line-height: 20px;
          }
        }

        .imgList {
          display: flex;
          flex-wrap: wrap;
          width: 120px;

          .imgs {
            margin: 0 10px 10px 0;
            position: relative;
            height: 50px;

            .index {
              position: absolute;
              top: -0px;
              left: -0px;
              width: 15px;
              height: 15px;
              background-color: #B4272D;
              border-radius: 50%;
              text-align: center;
              line-height: 15px;
              color: #fff;
              z-index: 99;
            }

            .el-icon-open {
              position: absolute;
              bottom: 0px;
              right: 0;
              width: 18px;
              padding: 0;
            }

            &:nth-child(even) {
              margin-right: 0;
            }

            &:nth-child(n + 2) {
              margin-bottom: 0;
            }


          }
        }
      }



      .img {
        img {
          width: 60px;
          height: 60px;
          border-radius: 4px;
        }
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 3px;

      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .el-image {
        height: 50px;
        width: 50px;
        border-radius: 4px;
      }
    }

    .flex05 {
      flex: 0.5;
      position: relative;

      .chong {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        text-align: center;
        line-height: 25px;
        color: #fff;
        position: absolute;
        top: 50%;
        left: 20px;
        background-color: #2C96E7;
      }
    }

    .flex15 {
      flex: 1.3;
    }

    .flex2 {
      flex: 1.8;
    }

    .remark-border {
      border: 1px solid #ccc;
      border-right: 0;
      display: block;
      text-align: left;
      word-break: break-all;
    }

    .important {
      background-color: #fee0c3;
    }

    .detail {

      .head {
        height: 50px;
        display: flex;
        background: #7080b1;
        font-size: 14px;
        padding: 0 20px;
        color: #fff;
        margin: 5px 0;

        .inco {
          margin-right: 24px;
          display: flex;
          align-items: center;
          font-size: 20px;
          cursor: pointer;
        }

        .item {
          display: flex;
          align-items: center;
          width: 280px;
          line-height: 20px;
        }

        .problem {
          display: inline-block;
          width: 28px;
          height: 28px;
          background-color: #B4272D;
          vertical-align: middle;
          text-align: center;
          line-height: 28px;
          border-radius: 50%;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }

    .noData {
      padding: 20px 0;
      text-align: center;
    }

    .trading {
      padding: 12px;
      background-color: #dedeef;
      color: #000;
      position: relative;

      a {
        color: #000;
      }

      span {
        margin-left: 20px;
      }

      .urgent {
        position: absolute;
        top: 5px;
        right: 5px;
      }

      .prompt {
        color: #B4272D;
        font-size: 20px;
        font-weight: 600;
      }
    }

    .template {
      .row {
        margin-bottom: 10px;

        .status {
          display: flex;
          justify-content: space-between;

          i {
            font-size: 20px;
            margin-right: 5px;
            vertical-align: middle;
            color: #000;
          }
        }
      }
    }

  }

  .operation {
    position: sticky !important;
    left: 50%;
    bottom: 0;
    z-index: 999;
    margin-top: 20px;
    background-color: #edeff4;
    padding: 10px 24px;
    min-width: 1802px;
    border-radius: 5px 5px 0 0;

    // transform: translate(-50%, 0);
    .el-button {
      margin-left: 20px;
    }
  }
}

/deep/.el-dialog {
  margin-top: 50px !important;
}

.difference {
  color: #B4272D
}
</style>